import { createApp } from '@app/adapters/create-app'
import AccountMappingActions from '@app/application/account-mapping/components/account-mapping-actions'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='mapping-subheader-actions']").each(function () {
    const dataset = this.dataset

    createApp(AccountMappingActions, {
      authenticityToken: dataset.authenticityToken,
      saveMethod: dataset.method,
      asyncSaveUrl: dataset.asyncSaveUrl,
      saveUrl: dataset.url,
      saveBatchSize: parseInt(dataset.saveBatchSize),
      aiMode: typeof dataset.isAiMappingProposalSupported !== 'undefined',
    }).mount(this)
  })
})
